// extracted by mini-css-extract-plugin
export default {"root":"VerticalBarChart_root__B45L8","wrapper":"VerticalBarChart_wrapper__0-pAn"};